import { render, staticRenderFns } from "./SchoolTeacherLeaveControl.vue?vue&type=template&id=07d8f356&scoped=true&"
import script from "./SchoolTeacherLeaveControl.vue?vue&type=script&lang=js&"
export * from "./SchoolTeacherLeaveControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d8f356",
  null
  
)

export default component.exports